// this query for links ///

// $(document).ready(function () {
//   const currentHost = window.location.hostname.replace("www.", "");
//   const warningText = " (this link will open in a new tab)";

//   // List of known social platform URLs to exclude
//   const socialHosts = [
//     "facebook.com/outdooredgeknives/",
//     "instagram.com/outdooredgeknives/",
//     "youtube.com/channel/UCGuHmH4gyNLzSVl-ixk_ZdQ",
//     "advertise.bingads.microsoft.com"
//   ];

//   $('a[target="_blank"]').each(function () {
//     const $link = $(this);
//     const href = $link.attr("href") || "";

//     // 🚫 Skip tel:, mailto:, and empty href links
//     if (!href || href.startsWith("tel:") || href.startsWith("mailto:")) return;

//     // 🚫 Skip known social platform links
//     if (socialHosts.some(social => href.includes(social))) return;

//     const aria = $link.attr("aria-label");
//     if (aria && aria.includes(warningText)) return;

//     // Get visible text or image alt text
//     let labelText = $link.text().trim();
//     if (!labelText) {
//       const imgAlt = $link.find("img").attr("alt");
//       labelText = imgAlt ? imgAlt.trim() : "This link";
//     }

//     const newLabel = `${labelText}${warningText}`;

//     $link.attr({
//       "aria-label": newLabel,
//       title: newLabel
//     });

//     // Add required rel safety values
//     let relValue = $link.attr("rel") || "";
//     if (!relValue.includes("noopener")) relValue += " noopener";
//     if (!relValue.includes("noreferrer")) relValue += " noreferrer";
//     if (!relValue.includes("nofollow")) relValue += " nofollow";
//     $link.attr("rel", relValue.trim());

//     $link.addClass("external-link");

//     $link.on("focus", function () {
//       $(this).attr("aria-label", newLabel);
//     });
//   });
// });

// email ///
$(document).ready(function () {
  const currentHost = window.location.hostname.replace("www.", "");
  const warningText = " (this link will open in new tab)";

  $('a[href^="http://"], a[href^="https://"]').each(function () {
    const $link = $(this);
    const linkHost = this.hostname.replace("www.", "");

    if (linkHost === currentHost || !linkHost) return; // Skip internal links

    // Get text or fallback from image alt
    let linkText = $link.text().trim();
    if (!linkText) {
      const imgAlt = $link.find("img").attr("alt");
      linkText = imgAlt ? imgAlt.trim() : "this link";
    }

    // Build aria-label
    const currentAriaLabel = $link.attr("aria-label");
    const newLabel = currentAriaLabel
      ? `${currentAriaLabel}${warningText}`
      : `${linkText}${warningText}`;

    // Apply attributes
    $link.attr({
      "aria-label": newLabel,
      title: newLabel, // optional
      target: "_blank",
      rel: "noopener noreferrer nofollow",
    });

    // Add external-link class for styling
    $link.addClass("external-link");
  });
});

$(document).ready(function () {
  $('a[href^="mailto:"]').each(function () {
    let email = $(this).attr("href").replace("mailto:", "").trim();
    email = decodeURIComponent(email) // Handle %20, %40, etc.
      .split("?")[0] // Remove ?subject=...
      .split("&")[0]; // Remove &body=...

    $(this).attr("aria-label", "Email Address: " + email);
  });
});

// phone me ///
$(document).ready(function () {
  $('a[href^="tel:"]').each(function () {
    const $link = $(this);
    const visibleText = $link.text().trim(); // Get what's visually shown
    const existingLabel = $link.attr("aria-label") || "";

    if (!existingLabel.includes("Phone Number")) {
      const newLabel =
        `Phone Number: ${visibleText}` +
        (existingLabel ? `, ${existingLabel}` : "");
      $link.attr("aria-label", newLabel);
    }
  });
});

// tabs //
$(document).on("keydown click", "li[role='tab']", function (e) {
  if (e.type === "keydown") {
    if (
      e.key === "Enter" ||
      e.key === " " ||
      e.keyCode === 13 ||
      e.keyCode === 32
    ) {
      e.preventDefault();
      $(this).find("a")[0].click();
    }
  }

  if (e.type === "click" && e.target.tagName.toLowerCase() !== "a") {
    e.preventDefault();
    $(this).find("a")[0].click();
  }
});
// //
// css color////
$(document).ready(function () {
  $("<style>")
    .prop("type", "text/css")
    .html(
      ".buddha-menu-item .mm-label.sale { color: #fff !important; background-color: #3a7401 !important; }"
    );
});

// popup foucs//
// let $lastTriggerBtn = null;
// $(document).on('click', 'button[aria-controls^="quick-buy-template"]', function () {
//   $lastTriggerBtn = $(this);

//   setTimeout(() => {
//     const $modal = $('#quick-buy-modal-content');
//     if (!$modal.length) return;

//     const $focusable = $modal.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').first();
//     ($focusable.length ? $focusable : $modal.attr('tabindex', '-1')).focus();
//   }, 2000);
// });

$(".product-card__quick-buy button.button").on("click", function () {
  setTimeout(function () {
    $(".quick-buy-drawer").attr("tabindex", 0).focus();
  }, 1000);
});

$(".checkcart").on("click", function () {
  setTimeout(function () {
    $(".cart-drawer__top").attr("tabindex", 0).focus();
  }, 1000);
});


$(".product-card__quick-buy button").on("click", function () {
  setTimeout(function () {
    $(".cart-drawer__top").attr("tabindex", 0).focus();
  }, 2000);
});


$(".checkaddmob").on("click", function () {
  setTimeout(function () {
    $(".checkcorss").attr("tabindex", 0).focus();
  }, 1000);
});

$(".checkcart").on("click", function () {
  setTimeout(function () {
    $(".checkclose").attr("tabindex", 0).focus();
  }, 1000);
});
$(".checkcart").on("click", function () {
  setTimeout(function () {
    $(".checkcorss").attr("tabindex", 0).focus();
  }, 1000);
});
$(".checkquick").on("click", function () {
  setTimeout(function () {
    $(".checkclose").attr("tabindex", 0).focus();
  }, 1000);
});
$(".checkbuy").on("click", function () {
  setTimeout(function () {
    $(".checkclose").attr("tabindex", 0).focus();
  }, 1000);
});
$(".checkmobile").on("click", function () {
  setTimeout(function () {
    $(".checkedclose").attr("tabindex", 0).focus();
  }, 1000);
});
$(".checkser").on("click", function () {
  setTimeout(function () {
    $(".checkmoclose").attr("tabindex", 0).focus();
  }, 1000);
});
$(".checkapply").on("click", function () {
  setTimeout(function () {
    $(".checkfil").attr("tabindex", 0).focus();
  }, 1000);
});

$(".collection--filters-drawer facet-floating-filter button").on(
  "click",
  function () {
    setTimeout(function () {
      $("#facets-drawer button").attr("tabindex", 0).focus();
    }, 1000);
  }
);

// add label to quick buy button///
$(document).ready(function () {});

var existCondition = setInterval(function () {
  if ($(".product-card__figure ").length) {
    clearInterval(existCondition);
    runMyFunction07();
  }
}, 200);

function runMyFunction07() {
  console.log("Quick Add");

  $(".product-card__quick-buy").each(function () {
    // Get product title text from nearest product card
    const productTitle = $.trim(
      $(this).closest(".product-card").find(".product-card__title").text()
    );

    // Find the custom quick add button and set accessible aria-label
    $(this)
      .find("button[is='custom-button']")
      .attr("aria-label", `Quick add ${productTitle} to cart`);
  });
}

// corrtecting the heading//
$(document).ready(function () {
  $(".product-info__text h5").each(function () {
    const $this = $(this);
    $this.replaceWith(`<h2 style="font-size:24px;">${$this.html()}</h2>`);
  });
});

$(document).ready(function () {
  $(".metafield-rich_text_field h6").each(function () {
    const $this = $(this);
    $this.replaceWith(
      `<h2 class="${$this.attr("class") || ""}" style="${
        $this.attr("style") || ""
      }">${$this.html()}</h2>`
    );
  });

  $(".metafield-rich_text_field h2").css({
    "font-size": "0.875em",
    "font-weight": "bold",
    margin: "0.67em 0",
  });
});

// is this for shop  now//
$(document).ready(function () {
  // Loop through each section that contains heading and anchor
  $(".place-self-center").each(function () {
    // Get trimmed heading text
    var headingText = $.trim($(this).find(".h0").text());

    // Find the anchor
    var $anchor = $(this).find('a[role="button"]');

    // Get trimmed anchor text
    var anchorText = $.trim($anchor.text());

    // Combine both for aria-label
    var ariaLabel = headingText + ", " + anchorText;

    // Set aria-label attribute
    $anchor.attr("aria-label", ariaLabel);
  });
});

// is this for learn more/
$(document).ready(function () {
  $(".place-self-center").each(function () {
    // Get trimmed heading text from .h0
    var headingText = $.trim($(this).find(".h0").text());

    // Get trimmed text from <p class="h2">
    var h2Text = $.trim($(this).find("p.h2").text());

    // Find the anchor with class button--xl
    var $anchor = $(this).find('a.button--xl[role="button"]');

    // Get trimmed anchor text
    var anchorText = $.trim($anchor.text());

    // Combine all for aria-label
    var ariaLabel = anchorText + ", " + headingText + ", " + h2Text;

    // Set aria-label attribute
    $anchor.attr("aria-label", ariaLabel);
  });
});

// // add to cart//
// $(document).ready(function () {
//   // Get product title text from the h1 element
//   const productTitle = $.trim($(".product-info__title").text());

//   // Find the custom button and set aria-label
//   $("button[is='custom-button']").each(function () {
//     $(this).attr("aria-label", `Add to cart ${productTitle}`);
//   });
// });

$(document).ready(function () {
  function announceCurrentImageAlt() {
    const $activeButton = $('.timeline__nav-item[aria-current="true"]');
    const activeIndex = $activeButton.index();

    const $allImages = $(".timeline__image-wrapper img");
    const $currentImage = $allImages.eq(activeIndex);
    const altText = $currentImage.attr("alt") || "Timeline image";

    $("#timeline-alt-announcer").remove();

    const $liveRegion = $("<div>", {
      id: "timeline-alt-announcer",
      "aria-live": "polite",
      class: "sr-only",
      text: altText,
    });

    $("body").append($liveRegion);
  }

  $('button[is="next-button"], button[is="prev-button"]').on(
    "click",
    function () {
      setTimeout(announceCurrentImageAlt, 600);
    }
  );

  $(".timeline__nav-item").on("click", function () {
    setTimeout(announceCurrentImageAlt, 600);
  });

  announceCurrentImageAlt();
});

// $(document).ready(function () {
// $(".h2.razorsafe").first().attr("aria-level", "1");
// });
// $(document).ready(function () {
// $(".h2.BestSellers").first().attr("aria-level", "2");
// });

///add aria-hidden="true" on all br tags
$(document).ready(function () {
  $("br").attr("aria-hidden", "true");
  $("hr").attr("aria-hidden", "true");
});

// contact form btn label
$(document).ready(function () {
  $("#customer_login")
    .find('button[type="submit"]')
    .attr(
      "aria-label",
      "Login, upon successful submission, the page will be refresh"
    );
});
// register form
$(document).ready(function () {
  $("#create_customer")
    .find('button[type="submit"]')
    .attr(
      "aria-label",
      "Create account, upon successful submission, the page will be refresh"
    );
});


$(document).ready(function () {
  function addAriaLabels() {
    $('a[href*="/products/"]').each(function () {
      var $link = $(this);

      // Skip if already has aria-label
      if ($link.attr('aria-label')) return;

      // Get first image alt text
      var altText = $link.find('img').first().attr('alt');

      if (altText) {
        var labelText = altText
          .replace(/["']/g, '')                 // remove quotes
          .replace(/\(.*?\)/g, '')              // remove anything in parentheses e.g. (test)
          .replace(/-\s*\d+\s*inch/gi, '')      // remove "-1 inch", "-2 inch", etc.
          .replace(/-?\s*outdoor edge/gi, '')   // remove "-Outdoor Edge"
          .replace(/(\d+(\.\d+)?)\s*(?=$|[^a-zA-Z])/g, '$1 inch ') // add "inch" after number
          .replace(/\s*\|\s*/g, ' | ')          // normalize pipes
          .replace(/\s*-\d-.*/i, '')            // remove trailing -1-, -2-, etc.
          .replace(/\s+/g, ' ')                 // clean extra spaces
          .trim();

        $link.attr('aria-label', labelText.toLowerCase());
      }
    });
  }

  // Run once on page load
  addAriaLabels();

  // Watch for dynamically added products (AJAX etc.)
  const observer = new MutationObserver(function () {
    addAriaLabels();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// checkout label///
jQuery(function($){
  // Select button or link inside the container and only add if not already present
  $('.buy-buttons.buy-buttons--compact').find('button, a').each(function(){
    var $el = $(this);
    if (!$el.attr('aria-label')) {
      $el.attr('aria-label', 'Proceed to checkout page');
    }
  });
});


// Ensure jQuery is ready AND Shopify sections are loaded

